import {
    CHILD_OBJECT_INVALID,
    PARENT_OBJECT_INVALID,
    PARENT_TYPE_INVALID,
    Schema,
} from '@gitbook/slate';

import { BLOCK_QUOTE, BLOCKS, FRAGMENT_EXPANDABLE_BODY } from '../types';
import { unwrapChildren, wrapInlinesInParagraph } from '../utils';

/**
 * Schema to validate quotes.
 */
export const schema = Schema.create({
    blocks: {
        [BLOCK_QUOTE]: {
            parent: {
                objects: ['document', 'fragment', 'block'],
                types: [undefined, ...BLOCKS, FRAGMENT_EXPANDABLE_BODY],
            },
            nodes: [{ objects: ['block'] }],
            isVoid: false,
            normalize: Schema.createNormalize({
                [PARENT_OBJECT_INVALID]: (change, context) => unwrapChildren(change, context.node),
                [PARENT_TYPE_INVALID]: (change, context) => unwrapChildren(change, context.node),
                [CHILD_OBJECT_INVALID]: (change, context) =>
                    // @ts-expect-error
                    wrapInlinesInParagraph(change, context.node.key),
            }),
        },
    },
});
